import { API_ROUTES } from "./apiRoutes";
import api from "./axiosInstance";

export const getAnnouncementApi = async (data) => {
  const res = await api.get(API_ROUTES.ANNOUNCEMENT.LIST, {
    params: { ...data },
  });
  return res.data;
};
export const createAnnouncementApi = async (data) => {
  const res = await api.post(API_ROUTES.ANNOUNCEMENT.CREATE, data);
  return res.data;
};
// 🔹 update item
export const updateAnnouncementApi = async (data) => {
  const { _id, ...payload } = data;
  const res = await api.put(API_ROUTES.ANNOUNCEMENT.EDIT(_id), payload);
  return res.data;
};
export const deleteAnnouncementApi = async (data) => {
  const { _id } = data;
  const res = await api.delete(API_ROUTES.ANNOUNCEMENT.DELETE(_id));
  return res.data;
};
